/* Custom Cart Drawer — hoort bij sections/custom-cart-drawer.liquid */
(function () {
  if (window.__customCartDrawerLoaded) return;
  window.__customCartDrawerLoaded = true;

  var ROOT_ID = 'CustomCartDrawer';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var lastFocus = null;
  var busy = false;
  var refreshTimer = null;
  var openAfterRefresh = false;
  var internalCalls = 0;
  var pendingQty = {};
  var qtyTimers = {};

  function root() { return document.getElementById(ROOT_ID); }
  function cfg(name) { var r = root(); return r ? r.getAttribute('data-' + name) : null; }
  function isOpen() { var r = root(); return !!(r && r.classList.contains('is-open')); }
  function sectionId() { return cfg('section-id') || 'custom-cart-drawer'; }
  function rootUrl() { return (cfg('root-url') || '/').replace(/\/$/, '') + '/'; }
  function dispatch(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function onCartPage() {
    var cartUrl = (cfg('cart-url') || '/cart').replace(/\/$/, '');
    return window.location.pathname.replace(/\/$/, '') === cartUrl;
  }

  /* Eigen winkelwagen-verzoeken lopen via de actuele window.fetch, zodat
     Shopify-analytics en pixels (Meta, Google) 'toegevoegd aan winkelwagen' blijven zien. */
  function cartFetch(url, options) {
    var opts = Object.assign({ __ccd: true }, options);
    internalCalls++;
    try {
      return window.fetch(url, opts);
    } finally {
      internalCalls--;
    }
  }

  function parseJSON(res) {
    return res.json().catch(function () { return {}; }).then(function (data) {
      return { ok: res.ok, data: data || {} };
    });
  }

  /* ---------- Openen / sluiten ---------- */
  function setToggles(expanded) {
    document.querySelectorAll('[data-cart-toggle]').forEach(function (node) {
      node.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function open() {
    var r = root();
    if (!r) return;
    if (!isOpen()) lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ccd-lock');
    setToggles(true);
    var panel = r.querySelector('.ccd__panel');
    window.setTimeout(function () { if (panel && isOpen()) panel.focus({ preventScroll: true }); }, 50);
    dispatch('ccd:open');
  }

  function close() {
    var r = root();
    if (!r || !isOpen()) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ccd-lock');
    setToggles(false);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    dispatch('ccd:close');
  }

  /* ---------- Renderen ---------- */
  function updateCounts(count) {
    var r = root();
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      if (r && r.contains(node)) return;
      node.textContent = count;
      node.hidden = count === 0;
    });
  }

  function applySections(sections) {
    var html = sections && sections[sectionId()];
    var r = root();
    if (!html || !r) return false;

    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ccd-content]');
    var current = r.querySelector('[data-ccd-content]');
    if (!fresh || !current) return false;

    var list = current.querySelector('[data-ccd-items]');
    var scrollTop = list ? list.scrollTop : 0;
    var active = document.activeElement;
    var focusKey = active && current.contains(active) ? active.getAttribute('data-ccd-focus') : null;

    current.innerHTML = fresh.innerHTML;
    current.setAttribute('data-count', fresh.getAttribute('data-count') || '0');

    var newList = current.querySelector('[data-ccd-items]');
    if (newList) newList.scrollTop = scrollTop;

    /* Aantallen die nog onderweg zijn niet laten terugspringen */
    Object.keys(pendingQty).forEach(function (key) {
      var pendingInput = current.querySelector('[data-ccd-qty-input][data-key="' + CSS.escape(key) + '"]');
      if (pendingInput) pendingInput.value = pendingQty[key];
    });

    if (focusKey) {
      var target = current.querySelector('[data-ccd-focus="' + CSS.escape(focusKey) + '"]');
      var panel = r.querySelector('.ccd__panel');
      (target || panel).focus({ preventScroll: true });
    }

    updateCounts(Number(fresh.getAttribute('data-count')) || 0);
    dispatch('ccd:render');
    return true;
  }

  function refresh() {
    return nativeFetch(rootUrl() + '?sections=' + encodeURIComponent(sectionId()), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (sections) { applySections(sections); })
      .catch(function (err) { console.error('[cart drawer] refresh failed', err); });
  }

  function scheduleRefresh(openWhenDone) {
    if (openWhenDone) openAfterRefresh = true;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      var shouldOpen = openAfterRefresh;
      openAfterRefresh = false;
      refresh().then(function () {
        if (shouldOpen && cfg('open-on-add') === 'true' && !onCartPage()) open();
      });
    }, 120);
  }

  function showError(message) {
    var r = root();
    var el = r && r.querySelector('[data-ccd-error]');
    if (!el) return;
    el.textContent = message || cfg('error-text') || 'Something went wrong.';
    el.hidden = false;
    window.clearTimeout(showError.t);
    showError.t = window.setTimeout(function () { el.hidden = true; }, 5000);
  }

  /* ---------- Aantal wijzigen / verwijderen ---------- */
  function queueQuantity(key, quantity, delay) {
    if (!key) return;
    pendingQty[key] = Math.max(0, quantity);
    window.clearTimeout(qtyTimers[key]);
    qtyTimers[key] = window.setTimeout(function () { flushQuantity(key); }, delay);
  }

  function flushQuantity(key) {
    if (!(key in pendingQty)) return;
    if (busy) {
      qtyTimers[key] = window.setTimeout(function () { flushQuantity(key); }, 150);
      return;
    }
    var quantity = pendingQty[key];
    delete pendingQty[key];
    changeLine(key, quantity);
  }

  function changeLine(key, quantity) {
    if (busy || !key) return;
    busy = true;
    var r = root();
    var row = r && r.querySelector('[data-ccd-item][data-key="' + CSS.escape(key) + '"]');
    if (row) row.classList.add('is-busy');

    cartFetch((cfg('change-url') || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, quantity),
        sections: sectionId(),
        sections_url: window.location.pathname
      })
    })
      .then(parseJSON)
      .then(function (res) {
        if (!res.ok) {
          return refresh().then(function () { showError(res.data.description || res.data.message); });
        }
        if (!applySections(res.data.sections)) return refresh();
        dispatch('ccd:change', res.data);
      })
      .catch(function () {
        return refresh().then(function () { showError(); });
      })
      .then(function () {
        busy = false;
        if (row) row.classList.remove('is-busy');
      });
  }

  /* ---------- Toevoegen aan winkelwagen ---------- */
  function formError(form, message) {
    var el = form.querySelector('[data-add-to-cart-error]');
    var text = message || (el && el.getAttribute('data-generic-error')) || cfg('error-text');
    if (el) {
      el.textContent = text;
      el.hidden = false;
    } else {
      window.alert(text);
    }
  }

  function addFromForm(form, submitter) {
    var button = submitter || form.querySelector('[name="add"], [data-add-to-cart], [type="submit"]');
    if (button && button.getAttribute('aria-busy') === 'true') return;

    var label = button && button.querySelector('[data-add-to-cart-label]');
    var labelText = label ? label.textContent : null;
    var wasDisabled = button ? button.disabled : false;
    var errorEl = form.querySelector('[data-add-to-cart-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var formData = new FormData(form);
    formData.append('sections', sectionId());
    formData.append('sections_url', window.location.pathname);

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label && cfg('adding-label')) label.textContent = cfg('adding-label');
    }

    cartFetch((cfg('add-url') || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(parseJSON)
      .then(function (res) {
        if (!res.ok) {
          formError(form, res.data.description || res.data.message);
          return;
        }
        var done = applySections(res.data.sections) ? Promise.resolve() : refresh();
        return done.then(function () {
          if (cfg('open-on-add') === 'true') open();
          dispatch('ccd:added', res.data);
        });
      })
      .catch(function () { formError(form, null); })
      .then(function () {
        if (!button) return;
        button.disabled = wasDisabled;
        button.removeAttribute('aria-busy');
        if (label && labelText !== null) label.textContent = labelText;
      });
  }

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-ccd-ignore')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!root()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFromForm(form, event.submitter);
  }, true);

  /* ---------- Winkelwagen-icoon onderscheppen ---------- */
  window.addEventListener('click', function (event) {
    var target = event.target;
    var r = root();
    if (!r || !(target instanceof Element) || r.contains(target) || onCartPage()) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var cartUrl = cfg('cart-url') || '/cart';
    var trigger = target.closest('[data-cart-toggle], [data-ccd-open], a[href="' + cartUrl + '"], a[href="' + cartUrl + '/"]');
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- Klikken in de drawer ---------- */
  document.addEventListener('click', function (event) {
    var r = root();
    var target = event.target instanceof Element ? event.target : null;
    if (!r || !target || !r.contains(target)) return;

    if (target.closest('[data-ccd-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var qtyBtn = target.closest('[data-ccd-qty]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var input = r.querySelector('[data-ccd-qty-input][data-key="' + CSS.escape(key) + '"]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      var next = Math.max(0, current + Number(qtyBtn.getAttribute('data-ccd-qty')));
      if (input) input.value = next;
      queueQuantity(key, next, 350);
      return;
    }

    var removeBtn = target.closest('[data-ccd-remove]');
    if (removeBtn) queueQuantity(removeBtn.getAttribute('data-key'), 0, 0);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    var r = root();
    if (!r || !(input instanceof HTMLInputElement) || !input.hasAttribute('data-ccd-qty-input') || !r.contains(input)) return;
    var value = parseInt(input.value, 10);
    queueQuantity(input.getAttribute('data-key'), isNaN(value) ? 0 : value, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key === 'Enter' && event.target instanceof HTMLInputElement && event.target.hasAttribute('data-ccd-qty-input')) {
      event.preventDefault();
      event.target.blur();
      return;
    }

    if (event.key !== 'Tab') return;
    var panel = root().querySelector('.ccd__panel');
    var nodes = Array.prototype.filter.call(
      panel.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; }
    );
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Wijzigingen door andere scripts/apps oppikken ---------- */
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    if (internalCalls > 0 || (init && init.__ccd)) return promise;
    try {
      var url = typeof Request !== 'undefined' && input instanceof Request ? input.url : String(input);
      if (CART_RE.test(url)) {
        promise.then(function (res) {
          if (res.ok) scheduleRefresh(/\/cart\/add/.test(url));
        }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ccdUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__ccdUrl && CART_RE.test(xhr.__ccdUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) scheduleRefresh(/\/cart\/add/.test(xhr.__ccdUrl));
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* Terug-knop (bfcache) kan een oude winkelwagen tonen */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  /* Thema-editor: drawer tonen als de sectie geselecteerd is */
  document.addEventListener('shopify:section:select', function (event) {
    if (event.detail && event.detail.sectionId === sectionId()) open();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.detail && event.detail.sectionId === sectionId()) close();
  });

  window.CustomCartDrawer = { open: open, close: close, refresh: refresh };
})();